module.exports = __webpack_public_path__ + "img/adobe-vs-magento-img.350f0d1f.webp";